import { Component, inject, ViewChild } from '@angular/core';
import { MatInputModule } from '@angular/material/input';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle
} from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { TrackData } from '@shared/interfacres/track';
import { Playlist } from '@shared/interfacres/playlist';
import { MatButton } from '@angular/material/button';

// import { MatIcon } from '@angular/material/icon';
import { DatePipe } from '@angular/common';
import {
  MatCell,
  MatCellDef,
  MatColumnDef,
  MatHeaderCell, MatHeaderCellDef,
  MatHeaderRow,
  MatHeaderRowDef, MatRow, MatRowDef, MatTable
} from '@angular/material/table';
import { MatCheckbox } from '@angular/material/checkbox';
import { MatSort } from '@angular/material/sort';
import { SelectionModel } from '@angular/cdk/collections';
import { MatPaginator } from '@angular/material/paginator';
// import { CdkDrag, CdkDragDrop, CdkDropList, moveItemInArray } from '@angular/cdk/drag-drop';
import { SecondsToTimePipe } from '@shared/pipes/secondsToMinutes';

@Component({
  selector: 'app-edit-playlist-tracks-dialog',
  templateUrl: 'edit-playlist-tracks-dialog.html',
  styleUrl: './edit-playlist-tracks-dialog.scss',
  imports: [
    MatFormFieldModule,
    MatInputModule,
    FormsModule,
    MatDialogTitle,
    MatDialogContent,
    MatDialogActions,
    MatButton,

    // MatIcon,
    ReactiveFormsModule,
    DatePipe,
    MatCell,
    MatCellDef,
    MatCheckbox,
    MatColumnDef,
    MatHeaderCell,
    MatHeaderRow,
    MatHeaderRowDef,
    MatRow,
    MatRowDef,
    MatTable,
    MatHeaderCellDef,
    // CdkDropList,
    // CdkDrag,
    SecondsToTimePipe,
  ],
})
export class EditPlaylistTracksDialog {
  readonly dialogRef = inject(MatDialogRef<EditPlaylistTracksDialog>);
  readonly data = inject<{name: string; tracks: TrackData[]}>(MAT_DIALOG_DATA);

  dataSource = this.data.tracks;
  name = this.data.name;


  selection = new SelectionModel<number>(
    true,
    []
  );

  displayedColumns: string[] = ['id', 'name', 'duration', 'download', 'date'];
  // dataSource: Genre[] = [];
  total = this.data.tracks.length;
  searchValue = new FormControl('');

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  @ViewChild('table', { static: true }) table: MatTable<Playlist> | undefined;

  // drop(event: CdkDragDrop<string>) {
  //   const previousIndex = this.dataSource.findIndex((d) => d === event.item.data);
  //   moveItemInArray(this.dataSource, previousIndex, event.currentIndex);
  //   this.table!.renderRows();
  // }

  bulkDelete() {
    this.dialogRef.close(this.selection.selected);
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
}
